module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    on: {
      "change": _vm.getDevices
    },
    model: {
      value: (_vm.filters.projectId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "projectId", $$v)
      },
      expression: "filters.projectId"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.projectId,
      attrs: {
        "label": item.name,
        "value": item.projectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点位名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    on: {
      "change": _vm.getFactorsByMn
    },
    model: {
      value: (_vm.filters.mn),
      callback: function($$v) {
        _vm.$set(_vm.filters, "mn", $$v)
      },
      expression: "filters.mn"
    }
  }, _vm._l((_vm.devices), function(item) {
    return _c('el-option', {
      key: item.mnCode,
      attrs: {
        "label": item.name,
        "value": item.mnCode
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.type == 0) ? _c('el-form-item', {
    attrs: {
      "label": "设备编码"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    on: {
      "change": _vm.getFactorsByMn
    },
    model: {
      value: (_vm.filters.mn),
      callback: function($$v) {
        _vm.$set(_vm.filters, "mn", $$v)
      },
      expression: "filters.mn"
    }
  }, _vm._l((_vm.devices), function(item) {
    return _c('el-option', {
      key: item.mnCode,
      attrs: {
        "label": item.mnCode,
        "value": item.mnCode
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "因子"
    }
  }, [_c('el-select', {
    staticStyle: {
      "max-width": "150px"
    },
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.filters.facKeyword),
      callback: function($$v) {
        _vm.$set(_vm.filters, "facKeyword", $$v)
      },
      expression: "filters.facKeyword"
    }
  }, _vm._l((_vm.factors), function(item) {
    return _c('el-option', {
      key: item.keyword,
      attrs: {
        "label": item.name,
        "value": item.keyword
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.filters.time),
      callback: function($$v) {
        _vm.$set(_vm.filters, "time", $$v)
      },
      expression: "filters.time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('form-query-button', {
    on: {
      "select-type": _vm.getAnalysisData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "border": "",
      "highlight-current-row": "",
      "size": "small",
      "id": "mytable"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "点位名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.deviceMap.get(scope.row["mn"])))])]
      }
    }])
  }), _vm._v(" "), (_vm.type == 0) ? _c('el-table-column', {
    attrs: {
      "prop": "mn",
      "label": "设备编码"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "数据类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 0) ? _c('span', [_vm._v("自动数据")]) : (scope.row.type == 1) ? _c('span', [_vm._v("手工数据")]) : _c('span', [_vm._v("差值")])]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.aData), function(item, i) {
    return _c('el-table-column', {
      key: item,
      attrs: {
        "prop": item,
        "label": item,
        "min-width": "60"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.type == 2 && (scope.row.list[i] > 1 || scope.row.list[i] < -1)) ? _c('span', {
            staticStyle: {
              "color": "red",
              "font-weight": "bold"
            }
          }, [_vm._v(_vm._s(scope.row.list[i]))]) : _c('span', [_vm._v(_vm._s(scope.row.list[i]))])]
        }
      }], null, true)
    })
  })], 2), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "chartLine"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-21830e2a"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/uploadNoise/DataComparison.vue
// module id = 1883
// module chunks = 1